import React from 'react';

export default function Contact() {
  return (
    <section id="contact" className="contact-section">
      <div className="container-x">
        <header className="section-head">
          <h2 data-reveal="">Let's build something <em>worth shipping.</em></h2>
        </header>

        <p className="contact-big" data-reveal="">
          Drop a line at <a href="mailto:rbertainaloichemol@gmail.com">rbertainaloichemol@gmail.com</a>
          {' '}<em>— open to junior &amp; internship roles in cybersec, systems and product engineering.</em>
        </p>

        <div className="contact-grid" data-reveal="" data-reveal-delay="1">
          <a className="contact-card" href="mailto:rbertainaloichemol@gmail.com">
            <span className="label">— Email</span>
            <span className="v">rbertainaloichemol@gmail.com</span>
            <svg className="arrow" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.4"><path d="M3 11L11 3M5 3h6v6" /></svg>
          </a>
          <a className="contact-card" href="https://www.linkedin.com/in/raphbl/" target="_blank" rel="noopener noreferrer">
            <span className="label">— LinkedIn</span>
            <span className="v">/in/raphbl</span>
            <svg className="arrow" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.4"><path d="M3 11L11 3M5 3h6v6" /></svg>
          </a>
          <a className="contact-card" href="https://github.com/raph-bl" target="_blank" rel="noopener noreferrer">
            <span className="label">— GitHub</span>
            <span className="v">@raph-bl</span>
            <svg className="arrow" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.4"><path d="M3 11L11 3M5 3h6v6" /></svg>
          </a>
          <div className="contact-card">
            <span className="label">— Discord</span>
            <span className="v">skriptonit</span>
            <span className="micro" style={{ opacity: .6 }}>never changing it</span>
          </div>
        </div>
      </div>
    </section>
  );
}
